import React from "react";
import { useCallback, useContext, useEffect, useState } from "react";
import AuthContext from "../../../hooks/authContext";
import { getAllClientsByCompany } from "../../../services/apiservices/employee";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import CommunicationsCard from "./CommunicationsCard";
import styles from "../dashboard.module.scss";
import { getRecentClientMessagesByCompany } from "../../../services/apiservices/messages";
import { formDateCustom } from "../../../services/helpers";

const ClientMessages = React.memo(() => {
  const auth = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [channels, setChannels] = useState([]);
  const [clients, setClients] = useState(false);

  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;

  const getMessages = useCallback(() => {
    getAllClientsByCompany(companyId, async (res) => {
      const clientsList = res?.data;

      if (!clientsList?.length) {
        setClients(true);
        return;
      }
      setClients(false);

      const clientIds = auth?.userProfile?.role === "Client" ? [clientId] : clientsList?.map((c) => c?.id);

      getRecentClientMessagesByCompany(companyId, clientIds, (channelsData) => {
        setChannels(channelsData?.channels);

        const messageMap = new Map();

        channelsData?.result?.forEach((channel) => {
          channel?.messages?.forEach((item) => {
            const key = `${channel?.channelId}_${item?.sender?.userId}`;
            const existing = messageMap.get(key);

            if (!existing || new Date(item?.createdOn) > new Date(existing?.createdOn)) {
              messageMap?.set(key, {
                user: (
                  <>
                    {item?.sender?.firstName ?? ""} {item?.sender?.lastName ?? ""}{" "}
                    ({channel?.channelName ?? ""})
                  </>
                ),
                time: formDateCustom(item?.createdOn),
                preview: item?.message ?? "",
                id: channel?.channelId,
              });
            }
          });
        });

        const sortedMessages = Array.from(messageMap.values())
          ?.sort((a, b) => new Date(b?.time) - new Date(a?.time));

        setData(sortedMessages?.slice(0, 5));
      });
    });
  }, [auth?.userProfile, companyId, clientId]);

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  return (
    <CommunicationsCard
      icon={<ChatBubbleOutlineOutlinedIcon className={styles.iconGreen} />}
      updates={data}
      title="Client Messages"
      count={0}
      to="/communications/message-board/live-chat"
      viewAll="/communications/message-board/live-chat"
      client={clients}
      channels={channels}
    />
  );
});

export default ClientMessages;